import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IPatientState } from 'entities/Patient/Patient.models';
import { patientReducers } from 'entities/Patient/Patient.reducers';
import { patientEffects } from 'entities/Patient/Patient.effects';

export const patient = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
  } as IPatientState,
  reducers: patientReducers,
  effects: patientEffects,
});
